import type { Stylable } from '@core/utils/types'
import { Button } from '@design/components/buttons/button/Button'
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@design/ui/empty'
import { cn } from 'cn'
import type { ReactNode } from 'react'

interface EmptyScreenAction {
  label: string
  icon?: ReactNode
  href?: string
  onClick?: () => void
}

interface EmptyScreenProps extends Stylable {
  icon: ReactNode
  title?: string
  description?: ReactNode
  action?: EmptyScreenAction
  children?: ReactNode
}

export function EmptyScreen({
  icon,
  title,
  description,
  action,
  children,
  className,
}: EmptyScreenProps) {
  return (
    <Empty className={cn('my-auto', className)}>
      <EmptyHeader>
        <EmptyMedia variant='icon'>{icon}</EmptyMedia>
        {title && <EmptyTitle>{title}</EmptyTitle>}
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {(action || children) && (
        <EmptyContent>
          {action &&
            (action.href ? (
              <Button asChild>
                <a href={action.href}>
                  {action.icon}
                  {action.label}
                </a>
              </Button>
            ) : (
              <Button onClick={action.onClick}>
                {action.icon}
                {action.label}
              </Button>
            ))}
          {children}
        </EmptyContent>
      )}
    </Empty>
  )
}
